// File: src/components/AmountSelector.jsx
import React, { useState, useEffect } from "react";
import { formatPaymentAmount } from "./paymentCurrency.util";

export default function AmountSelector({
  initialCredits = 500,
  onChange,
  pricePerCreditCents = 18,
  currency = "usd",
}) {
  const presets = [500, 1000, 2000];
  const [credits, setCredits] = useState(initialCredits);

  useEffect(() => {
    const amountCents = credits * pricePerCreditCents;
    onChange &&
      onChange({
        credits,
        amountCents,
        amountDisplay: formatPaymentAmount(amountCents, currency),
      });
  }, [credits, pricePerCreditCents, currency, onChange]);

  const handleAmountChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D+/g, "");
    setCredits(value);
  };

  return (
    <div>
      <div className="mb-3 text-sm font-medium text-gray-700">
        Choose Reviews
      </div>

      <div className="flex gap-2 mb-3">
        {presets.map((p) => (
          <button
            key={p}
            onClick={() => setCredits(p)}
            className={`px-3 py-2 rounded-md border ${
              credits === p
                ? "bg-indigo-600 text-white border-indigo-600"
                : "bg-white text-gray-700 border-gray-200"
            }`}
          >
            {p} reviews
          </button>
        ))}
      </div>

      <div className="mb-3">
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Custom reviews
        </label>
        <input
          type="number"
          value={credits}
          min={500}
          onChange={handleAmountChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-300"
        />
      </div>

      <div className="text-sm text-gray-600">
        <span className="font-semibold">{credits}</span> reviews =&nbsp;
        <span className="font-medium">
          {formatPaymentAmount(credits * pricePerCreditCents, currency)}
        </span>
      </div>
    </div>
  );
}
